module.exports = __webpack_public_path__ + "img/bsks@2x.cc5d555c.png";